import { Injectable } from '@angular/core';
import { UrlTree } from '@angular/router';
import { concat, defer, Observable, of } from 'rxjs';
import { last } from 'rxjs/operators';

import { AuthenticationService } from '../services/authentication.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { EulaDialogComponent } from '../components/dialogs/eula-dialog/eula-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class EulaGuard  {

  constructor(
    private readonly dialog: MatDialog,
    private readonly authenticationService: AuthenticationService
  ) { }

  canActivate(): Observable<boolean | UrlTree> {
    let observables$ = of(true);
    if (this.authenticationService.shouldSignEula())
      observables$ = concat(this.runDialog(), this.authenticationService.refreshToken(), observables$);

    return observables$.pipe(last());
  }

  runDialog(): Observable<any> {
    return defer(() => {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = true;
      return this.dialog
        .open(EulaDialogComponent, dialogConfig)
        .afterClosed();
    });
  }
}
